import {createConstants} from '../utils';

export default createConstants(
	'LOGIN_USER_REQUEST',
	'LOGIN_USER_FAILURE',
	'LOGIN_USER_SUCCESS',
	'LOGOUT_USER',
	'CHANGE_USER_NAME',
	//dashboard
	'DASHBOARD_INDEX',
	//zones
	'FETCH_USERS_REQUEST',
	'FETCH_ZONES_REQUEST',
	'FETCH_ZONE_REQUEST',
	'RECEIVE_USERS',
	'RECEIVE_ZONE',
	'CREATE_ZONE_FORM',
	'EDIT_ZONE_FORM',
	'ZONE_FORM_SAVE',
	'ARTICLE_FORM_SAVE_SUCCESS',
	'UPDATE_ARTICLE',
	'DELETE_ARTICLE',
	'FETCH_PROTECTED_DATA_REQUEST',
	'RECEIVE_PROTECTED_DATA',
	//menus
	'FETCH_MENU_TYPES_REQUEST',
	'FETCH_ZONE_REQUEST',
	'CREATE_MENU_TYPE_FORM',
	'MENU_TYPE_FORM_SAVE',
	//customer
	'CHECK_PRODUCTION_OVERLAP_REQUEST',
	'RECEIVE_PRODUCTION_OVERLAP',	
	'UPDATE_CUSTOMER_FORM',
	'FETCH_CUSTOMER_REQUEST',
	'RECEIVE_CUSTOMER',
	'CUSTOMER_FORM_SAVE',
	'CUSTOMER_FORM_SAVE_SUCCESS',
	//invoice
	'FETCH_CUSTOMER_INVOICES_REQUEST',
	//order
	'FETCH_CUSTOMER_ORDERS_REQUEST',
	'CUSTOMER_ORDER_FETCH_PRODUCTS_REQUEST',
	'CUSTOMER_ORDER_RECEIVE_PRODUCTS',
		//order create
		'CUSTOMER_ORDER_FORM_CREATE',
		'CUSTOMER_ORDER_CREATE_SEND_FORM',
		'CUSTOMER_ORDER_CREATE_SAVE_SUCCESS',
		//order update
		'CUSTOMER_ORDER_FETCH_ORDER',
		'CUSTOMER_ORDER_RECEIVE_ORDER',
		'CUSTOMER_ORDER_UPDATE_FORM',
		'CUSTOMER_ORDER_UPDATE_REQUEST',
		'CUSTOMER_ORDER_UPDATE_SUCCESS',
		//active code
		'CUSTOMER_ORDER_FETCH_ACTIVE_CODE',
		'CUSTOMER_ORDER_RECEIVE_ACTIVE_CODE',
		//change password
		'CUSTOMER_CHANGE_PASSWORD_SUCCESS',
	//sample hardening
	'FETCH_SAMPLE_HARDENINGS_REQUEST',
	//register
	'CUSTOMER_REGISTER_REQUEST',
	'CUSTOMER_REGISTER_SUCCESS',
	'CUSTOMER_REGISTER_CONFIRM_REQUEST',
	'CUSTOMER_REGISTER_CONFIRM_SUCCESS'
);



/** WEBPACK FOOTER **
 ** ./js/constants/index.js
 **/